<div [class]="event.messageStatus === MessageStatus.UNREAD ? 'bullet' : 'bullet-free'">
  <div class="container-wrapper">
    <label>{{ elapsedTimeLabel }}</label>
    <div class="body">
      @switch (event.eventMessageType) {
        @case (EventMessageType.RATE_NOTIFICATION) {
          {{ 'notifications-page.notification.rate-notification.' + event.data.notificationDirection | translate:
          {
          tradingCurrency: event.data.currencyPair.tradingCurrency,
          contraCurrency: event.data.currencyPair.contraCurrency,
          rateLimitThreshold: event.data.rateLimitThreshold | decimalAmount: DecimalAmountPipe.AMOUNT_FORMAT_4_DIGITS
          } }}
        }
        @case (EventMessageType.UPCOMING_SETTLEMENT) {
          <span>{{ 'notifications-page.notification.upcoming-settlement' | translate:
            {
            currency: event.data[0].tradingCurrency,
            amount: event.data[0].hedgeAmount | decimalAmount,
            side: event.data[0].side | lowercase,
            settlementDate: event.data[0].hedgeDate | dateFormat
            } }}
          </span>
          @if (event.data.length > 1) {
            <span>{{ 'notifications-page.notification.more-items' | translate:
              {
              count: event.data.length - 1
              } }}
            </span>
          }
        }
        @case (EventMessageType.UPCOMING_TRADE_PLAN) {
          <span>{{ 'notifications-page.notification.upcoming-trade-plan' | translate:
            {
            eventName: event.data.eventName,
            projectName: event.data.projectName,
            companyShortName: event.data.companyCode | companyShortName
            } }}
          </span>
          @if (event.data.allEventIds.length > 1) {
            <p class="more-items">
              {{ 'notifications-page.notification.more-items' | translate:
              {count: event.data.allEventIds.length - 1}
              }}
            </p>
          }
          <div class="open-in-trading">
            {{ TRADE_PLAN_RATE_NOTIFICATION_TRANSLATE_PREFIX + 'open-in-trading' | translate }}
          </div>
        }
        @case (EventMessageType.TRADE_PLAN_RATE_NOTIFICATION) {
          <span>
            {{
              TRADE_PLAN_RATE_NOTIFICATION_TRANSLATE_PREFIX + tradePlanRateNotification.status | translate: {
                symbol: tradePlanRateNotification.symbol,
                threshold: tradePlanRateNotification.threshold | decimalAmount: DecimalAmountPipe.AMOUNT_FORMAT_4_DIGITS
              }
            }}
          </span>
          <div>
            {{
              TRADE_PLAN_RATE_NOTIFICATION_TRANSLATE_PREFIX + 'rate-alert-row-2' | translate: {
                projectName: tradePlanRateNotification.projectName,
                eventName: tradePlanRateNotification.eventName
              }
            }}
          </div>
          <div>
            {{
              TRADE_PLAN_RATE_NOTIFICATION_TRANSLATE_PREFIX + tradePlanRateNotification.hedgeSide | translate: {
                amount: tradePlanRateNotification.amount,
                tradingCurrency: tradePlanRateNotification.tradingCurrency,
              }
            }}
            @if (isDefined(tradePlanRateNotification.dueDate)) {
              <span>
                {{ tradePlanRateNotification.dueDate | dateFormat }}
              </span>
            }
            @if (isDefined(tradePlanRateNotification.tenor)) {
              <span>
                {{ 'tenor.' + tradePlanRateNotification.tenor | translate }}
              </span>
            }
          </div>
          @if (projectEventsCount > 1) {
            <p class="more-items">
              {{ 'notifications-page.notification.more-items' | translate: {count: projectEventsCount - 1} }}
            </p>
          }
          <div class="open-in-trading">
            {{ TRADE_PLAN_RATE_NOTIFICATION_TRANSLATE_PREFIX + 'open-in-trading' | translate }}
          </div>
        }
        @default {
        }
      }
    </div>
  </div>
</div>